// Traductions du site : identifiant -> { fr, en }.
// - Utilisation dans un composant : const { t } = useTranslation(); puis t('nav.clubs')
// - Paramètres : t('stats.parties', { n: 3 }) remplace {n} dans le texte
// - Une traduction anglaise absente affiche le texte français.
// Les identifiants sont regroupés par page / composant.
// Vocabulaire anglais (ITTF) : rencontre = team match, partie = match, manche = game.
export const translations = {

    // ---------- Commun ----------
    'common.loading': { fr: 'Chargement…', en: 'Loading…' },
    'common.close': { fr: 'Fermer', en: 'Close' },
    'common.club': { fr: 'Club', en: 'Club' },
    'common.vs': { fr: 'vs', en: 'vs' },
    'common.today': { fr: "Aujourd'hui", en: 'Today' },
    'common.upcoming': { fr: 'À venir', en: 'Upcoming' },
    'common.live': { fr: 'En direct', en: 'Live' },
    'common.finished': { fr: 'Terminé', en: 'Finished' },
    'common.win': { fr: 'Victoire', en: 'Win' },
    'common.loss': { fr: 'Défaite', en: 'Loss' },
    'common.wins': { fr: 'Victoires', en: 'Wins' },
    'common.losses': { fr: 'Défaites', en: 'Losses' },
    'common.noInfo': { fr: 'Aucune information disponible', en: 'No information available' },
    'common.back': { fr: 'Retour', en: 'Back' },
    'common.previous': { fr: 'Précédent', en: 'Previous' },
    'common.next': { fr: 'Suivant', en: 'Next' },
    'common.day': { fr: 'Journée {n}', en: 'Day {n}' },
    'common.dayShort': { fr: 'J{n}', en: 'D{n}' },
    'common.logoPro': { fr: 'Logo pro', en: 'Pro logo' },

    // ---------- Langue ----------
    'lang.label': { fr: 'Langue', en: 'Language' },
    'lang.fr': { fr: 'Français', en: 'French' },
    'lang.en': { fr: 'Anglais', en: 'English' },

    // ---------- Championnats ----------
    'champ.proam': { fr: 'Pro A Messieurs', en: 'Pro A Men' },
    'champ.proad': { fr: 'Pro A Dames', en: 'Pro A Women' },
    'champ.probm': { fr: 'Pro B Messieurs', en: 'Pro B Men' },
    'champ.probd': { fr: 'Pro B Dames', en: 'Pro B Women' },
    'champ.preprod': { fr: 'Préprod', en: 'Pre-production' },
    'champ.label': { fr: 'Championnat', en: 'Championship' },

    // ---------- Menu ----------
    'nav.clubs': { fr: 'CLUBS', en: 'CLUBS' },
    'nav.calendar': { fr: 'CALENDRIERS/RESULTATS', en: 'CALENDAR/RESULTS' },
    'nav.standings': { fr: 'CLASSEMENT', en: 'RANKING' },
    'nav.statistics': { fr: 'STATISTIQUES', en: 'STATISTICS' },
    'nav.contacts': { fr: 'CONTACTS', en: 'CONTACTS' },
    'nav.playoffs': { fr: 'PLAYOFFS', en: 'PLAYOFFS' },
    'nav.news': { fr: 'ACTUALITES', en: 'NEWS' },
    'nav.live': { fr: 'LIVE VIDEO', en: 'LIVE VIDEO' },
    'nav.docs': { fr: 'DOCUMENTATION', en: 'DOCUMENTATION' },
    'nav.openMenu': { fr: 'Ouvrir le menu', en: 'Open menu' },
    'nav.closeMenu': { fr: 'Fermer le menu', en: 'Close menu' },

    // ---------- Clubs (choix d'un club) ----------
    'clubs.title': { fr: 'Clubs', en: 'Clubs' },
    'clubs.titlePlayersM': { fr: 'Joueurs', en: 'Players' },
    'clubs.titlePlayersF': { fr: 'Joueuses', en: 'Players' },
    'clubs.subtitlePlayers': { fr: 'Choisissez un club pour découvrir son effectif', en: 'Choose a club to see its team' },
    'clubs.subtitleClubs': { fr: 'Choisissez un club pour voir ses contacts et sa salle', en: 'Choose a club to see its contacts and venue' },
    'clubs.seeTeam': { fr: "Voir l'effectif", en: 'See team' },
    'clubs.seeClub': { fr: 'Voir le club', en: 'See club' },

    // ---------- Actualités ----------
    'actus.title': { fr: 'Actualités', en: 'News' },
    'actus.subtitle': { fr: "Toute l'actualité des championnats Pro A et Pro B", en: 'All the news from the Pro A and Pro B championships' },
    'actus.empty': { fr: 'Aucune actualité pour le moment.', en: 'No news yet.' },
    'actus.latest': { fr: 'Dernières actualités', en: 'Latest news' },
    'actus.more': { fr: "Voir plus d'actualités", en: 'More news' },
    'actus.featured': { fr: 'À la une', en: 'Featured' },

    // ---------- Live vidéo ----------
    'live.title': { fr: 'Live vidéo', en: 'Live video' },
    'live.subtitle': { fr: 'Les matchs de Pro A et Pro B en direct sur la chaîne YouTube de la FFTT', en: 'Pro A and Pro B team matches live on the FFTT YouTube channel' },
    'live.emptyTitle': { fr: 'Aucun live pour le moment', en: 'No live stream at the moment' },
    'live.emptyText': { fr: "Aucun match n'est diffusé ou programmé actuellement. Retrouvez les replays sur la chaîne YouTube de la FFTT.", en: 'No team match is currently streamed or scheduled. Watch the replays on the FFTT YouTube channel.' },
    'live.seeChannel': { fr: 'Voir la chaîne', en: 'Go to the channel' },
    'live.onlyReplays': { fr: "Aucun match n'est diffusé ou programmé pour le moment. Revivez les dernières rencontres ci-dessous.", en: 'No team match is streamed or scheduled at the moment. Relive the latest team matches below.' },
    'live.replays': { fr: 'Replays', en: 'Replays' },
    'live.allVideos': { fr: 'Toutes les vidéos sur la chaîne FFTT', en: 'All videos on the FFTT channel' },

    // ---------- Documentation ----------
    'docs.surtitle': { fr: 'Espace documentaire', en: 'Documents' },
    'docs.title': { fr: 'Documentation', en: 'Documentation' },
    'docs.subtitle': { fr: 'Cahier des charges, calendriers et listes officielles au format PDF', en: 'Specifications, schedules and official lists in PDF format' },
    'docs.loading': { fr: 'Chargement des documents…', en: 'Loading documents…' },
    'docs.sections': { fr: 'Rubriques', en: 'Sections' },
    'docs.cat1': { fr: 'Cahier des charges', en: 'Specifications' },
    'docs.cat2': { fr: 'Calendriers officiels', en: 'Official schedules' },
    'docs.cat3': { fr: 'Listes Pro', en: 'Pro lists' },
    'docs.cat4': { fr: 'Listes des référents', en: 'Contact persons' },
    'docs.cat5': { fr: 'Tenues Sportives', en: 'Playing outfits' },
    'docs.cat6': { fr: 'Livescoring', en: 'Livescoring' },
    'docs.countOne': { fr: '{n} document', en: '{n} document' },
    'docs.countMany': { fr: '{n} documents', en: '{n} documents' },
    'docs.new': { fr: 'Nouveau', en: 'New' },
    'docs.added': { fr: 'Ajouté le {date}', en: 'Added on {date}' },
    'docs.open': { fr: 'Ouvrir', en: 'Open' },
    'docs.empty': { fr: 'Aucun document disponible pour le moment.', en: 'No document available yet.' },

    // ---------- Actualités (carte) ----------
    'actus.read': { fr: "Lire l'article", en: 'Read the article' },

    // ---------- Accueil ----------
    'home.videoTitle': { fr: 'Vidéo FFTT', en: 'FFTT video' },
    'home.playVideo': { fr: 'Lire la vidéo', en: 'Play the video' },

    // ---------- Phases finales ----------
    'phase.quarterShort': { fr: '1/4', en: 'QF' },
    'phase.semiShort': { fr: '1/2', en: 'SF' },
    'phase.finalShort': { fr: 'F', en: 'F' },
    'phase.quarter': { fr: '1/4 de finale', en: 'Quarter-final' },
    'phase.semi': { fr: '1/2 finale', en: 'Semi-final' },
    'phase.final': { fr: 'Finale', en: 'Final' },

    // ---------- Commun (suite) ----------
    'common.match': { fr: 'Rencontre', en: 'Team match' },

    // ---------- Cartes championnat (accueil) ----------
    'box.calendar': { fr: 'Calendrier', en: 'Calendar' },
    'box.standings': { fr: 'Classement', en: 'Ranking' },
    'box.previousDay': { fr: 'Journée précédente', en: 'Previous day' },
    'box.nextDay': { fr: 'Journée suivante', en: 'Next day' },
    'box.followLive': { fr: 'Suivre la rencontre en direct', en: 'Follow the team match live' },
    'box.seeMatch': { fr: 'Voir la rencontre', en: 'See the team match' },
    'box.liveScore': { fr: 'Score en direct', en: 'Live score' },
    'box.provisionalLegend': { fr: '* Résultat provisoire issu du livescoring, en attente de publication officielle', en: '* Provisional result from livescoring, awaiting official publication' },
    'box.fullCalendar': { fr: 'Tout le calendrier', en: 'Full calendar' },
    'box.fullStandings': { fr: 'Classement complet', en: 'Full ranking' },
    'box.fullBracket': { fr: 'Tout le tableau', en: 'Full bracket' },
    'box.regularSeason': { fr: 'Saison régulière', en: 'Regular season' },
    'box.regularSeasonShort': { fr: 'Saison rég.', en: 'Season' },
    'box.previousRound': { fr: 'Tour précédent', en: 'Previous round' },
    'box.nextRound': { fr: 'Tour suivant', en: 'Next round' },
    'box.roundNotScheduled': { fr: 'Rencontres pas encore programmées', en: 'Team matches not scheduled yet' },

    // ---------- Chargements ----------
    'loader.matches': { fr: 'Chargement des rencontres…', en: 'Loading team matches…' },
    'loader.standings': { fr: 'Chargement du classement…', en: 'Loading ranking…' },
    'loader.calendar': { fr: 'Chargement du calendrier…', en: 'Loading calendar…' },
    'loader.stats': { fr: 'Chargement des statistiques…', en: 'Loading statistics…' },
    'loader.matchSheet': { fr: 'Chargement de la feuille de match', en: 'Loading the score sheet' },

    // ---------- Rencontre ----------
    'match.provisionalTitle': { fr: 'Résultat provisoire (livescoring), en attente de publication officielle', en: 'Provisional result (livescoring), awaiting official publication' },
    'match.provisional': { fr: 'Provisoire', en: 'Provisional' },

    // ---------- Calendrier ----------
    'calendar.title': { fr: 'Calendrier / Résultats', en: 'Calendar / Results' },
    'calendar.allMatches': { fr: 'Toutes les rencontres', en: 'All team matches' },
    'calendar.quarters': { fr: 'Quarts de finale', en: 'Quarter-finals' },
    'calendar.semis': { fr: 'Demi-finales', en: 'Semi-finals' },
    'calendar.empty': { fr: 'Aucune rencontre programmée pour le moment.', en: 'No team match scheduled yet.' },

    // ---------- Phases finales (abréviations) ----------
    'phase.quarterAbbr': { fr: 'QF', en: 'QF' },
    'phase.semiAbbr': { fr: 'DF', en: 'SF' },

    // ---------- Classement ----------
    'standings.title': { fr: 'Classement', en: 'Ranking' },
    'standings.position': { fr: 'Position', en: 'Position' },
    'standings.ptsShort': { fr: 'Pts', en: 'Pts' },
    'standings.promotedProAD': { fr: 'Montée en Pro A Dames', en: 'Promoted to Pro A Women' },
    'standings.relegatedN1D': { fr: 'Descente en Nationale 1 Dames', en: 'Relegated to Nationale 1 Women' },
    'standings.playoffs': { fr: 'Playoffs', en: 'Playoffs' },
    'standings.playdown': { fr: 'Playdown', en: 'Playdown' },
    'standings.col.pts': { fr: 'Pts', en: 'Pts' },
    'standings.col.joue': { fr: 'MJ', en: 'P' },
    'standings.col.vic': { fr: 'V', en: 'W' },
    'standings.col.nul': { fr: 'N', en: 'D' },
    'standings.col.def': { fr: 'D', en: 'L' },
    'standings.col.pf': { fr: 'FF/P', en: 'FF/P' },
    'standings.col.pg': { fr: 'PG', en: 'MW' },
    'standings.col.pp': { fr: 'PP', en: 'ML' },
    'standings.colTitle.pts': { fr: 'Points', en: 'Points' },
    'standings.colTitle.joue': { fr: 'Matchs joués', en: 'Team matches played' },
    'standings.colTitle.vic': { fr: 'Victoires', en: 'Wins' },
    'standings.colTitle.nul': { fr: 'Nuls', en: 'Draws' },
    'standings.colTitle.def': { fr: 'Défaites', en: 'Losses' },
    'standings.colTitle.pf': { fr: 'Forfaits / Pénalités', en: 'Forfeits / Penalties' },
    'standings.colTitle.pg': { fr: 'Parties gagnées', en: 'Matches won' },
    'standings.colTitle.pp': { fr: 'Parties perdues', en: 'Matches lost' },

    // ---------- Page club ----------
    'club.contacts': { fr: 'Contacts', en: 'Contacts' },
    'club.venue': { fr: 'Salle', en: 'Venue' },
    'club.website': { fr: 'Site officiel du club', en: 'Official club website' },

    // ---------- Statistiques ----------
    'stats.pageTitle': { fr: 'Statistiques', en: 'Statistics' },

    // ---------- Calendrier d'un club ----------
    'clubCal.played': { fr: 'Joués', en: 'Played' },
    'clubCal.draws': { fr: 'Nuls', en: 'Draws' },
    'clubCal.nextMatch': { fr: 'Prochaine rencontre', en: 'Next team match' },
    'clubCal.home': { fr: 'Domicile', en: 'Home' },
    'clubCal.away': { fr: 'Extérieur', en: 'Away' },
    'clubCal.seasonOver': { fr: 'Saison terminée', en: 'Season over' },
    'clubCal.matches': { fr: 'Rencontres', en: 'Team matches' },
    'clubCal.empty': { fr: 'Aucune rencontre disponible pour le moment.', en: 'No team match available yet.' },

    // ---------- Statistiques (tableau) ----------
    'stats.titleM': { fr: 'Classement des joueurs', en: 'Player rankings' },
    'stats.titleF': { fr: 'Classement des joueuses', en: 'Player rankings' },
    'stats.rank': { fr: 'Rang', en: 'Rank' },
    'stats.playerM': { fr: 'Joueur', en: 'Player' },
    'stats.playerF': { fr: 'Joueuse', en: 'Player' },
    'stats.matchesPlayed': { fr: 'Rencontres jouées', en: 'Team matches played' },
    'stats.matchesLong': { fr: 'Rencontres', en: 'Team matches' },
    'stats.matchesShort': { fr: 'Renc.', en: 'Team matches' },
    'stats.played': { fr: 'jouées', en: 'played' },
    'stats.games': { fr: 'Parties', en: 'Matches' },
    'stats.gamesTitle': { fr: 'Parties gagnées : perdues', en: 'Matches won : lost' },
    'stats.sets': { fr: 'Manches', en: 'Games' },
    'stats.setsTitle': { fr: 'Manches gagnées : perdues', en: 'Games won : lost' },
    'stats.points': { fr: 'Points', en: 'Points' },
    'stats.pointsTitle': { fr: 'Points gagnés : perdus', en: 'Points won : lost' },
    'stats.detail': { fr: 'Détail', en: 'Details' },
    'stats.seeGames': { fr: 'Voir les parties', en: 'See matches' },
    'stats.seeGamesOf': { fr: 'Voir les parties de {name}', en: 'See the matches of {name}' },
    'stats.gamesOf': { fr: 'Parties de {name}', en: 'Matches of {name}' },
    'stats.empty': { fr: 'Aucune partie disputée pour le moment.', en: 'No match played yet.' },
    'stats.rankingNumber': { fr: 'Numéro de classement', en: 'Ranking number' },
    'stats.numberShort': { fr: 'N°{n}', en: 'No.{n}' },
    'stats.gamesCountOne': { fr: '{n} partie', en: '{n} match' },
    'stats.gamesCountMany': { fr: '{n} parties', en: '{n} matches' },
    'stats.winShort': { fr: 'V', en: 'W' },
    'stats.lossShort': { fr: 'D', en: 'L' },
    'stats.setsLower': { fr: 'manches', en: 'games' },
    'stats.pointsLower': { fr: 'points', en: 'points' },

    // ---------- Carte joueur ----------
    'player.flag': { fr: 'drapeau', en: 'flag' },
    'player.age': { fr: '{n} ans', en: '{n} years old' },
    'player.rightHanded': { fr: 'Droitier', en: 'Right-handed' },
    'player.leftHanded': { fr: 'Gaucher', en: 'Left-handed' },
    'player.worldRank': { fr: 'Class. mondial', en: 'World rank' },
    'player.frenchRank': { fr: 'Class. français', en: 'French rank' },
    'player.seePerformances': { fr: 'Voir les performances ({n})', en: 'See performances ({n})' },
    'player.noMatch': { fr: 'Aucun match disputé', en: 'No match played' },
    'player.matchCount': { fr: 'Match {n} / {total}', en: 'Match {n} / {total}' },

    // ---------- Rencontre (suite) ----------
    'match.inProgress': { fr: 'En cours', en: 'In progress' },
    'match.dayNumber': { fr: 'journée n°{n}', en: 'day {n}' },
    'match.spectators': { fr: 'Spectateurs', en: 'Spectators' },
    'match.gamesPlayedOne': { fr: '{n} partie disputée', en: '{n} match played' },
    'match.gamesPlayedMany': { fr: '{n} parties disputées', en: '{n} matches played' },

    // ---------- Partie ----------
    'game.timeoutTaken': { fr: 'Temps mort pris', en: 'Time-out taken' },
    'game.timeoutShort': { fr: 'T', en: 'T' },
    'game.history': { fr: 'Historique', en: 'History' },

    // ---------- Historique d'une partie ----------
    'history.title': { fr: 'Historique de la partie', en: 'Match history' },
    'history.refresh': { fr: 'Actualiser', en: 'Refresh' },
    'history.refreshing': { fr: 'Actualisation...', en: 'Refreshing...' },
    'history.empty': { fr: 'Aucun historique disponible pour cette partie.', en: 'No history available for this match.' },
    'history.noRally': { fr: 'Aucun échange enregistré pour cette manche.', en: 'No rally recorded for this game.' },
    'history.rallies': { fr: "Nombre d'échanges", en: 'Number of rallies' },
    'history.totalScore': { fr: 'Total score', en: 'Total score' },
    'history.streak': { fr: 'Points consécutifs', en: 'Consecutive points' },
    'history.setPoints': { fr: 'Balles de set', en: 'Game points' },
    'history.serviceWon': { fr: 'Service gagnant', en: 'Points won on serve' },
    'history.timeout': { fr: 'Temps mort', en: 'Time-out' },
    'history.yes': { fr: 'Oui', en: 'Yes' },
    'history.no': { fr: 'Non', en: 'No' },
    'history.setsWon': { fr: 'Total manche', en: 'Games won' },
    'history.total': { fr: 'Total', en: 'Total' },
    'history.setsLower': { fr: 'manches', en: 'games' },
    'history.set': { fr: 'Manche {n}', en: 'Game {n}' },
    'history.setShort': { fr: 'M{n}', en: 'G{n}' },

    // ---------- Vidéos ----------
    'video.button.live': { fr: 'Regarder en direct', en: 'Watch live' },
    'video.button.upcoming': { fr: 'Live programmé', en: 'Scheduled live' },
    'video.button.replay': { fr: 'Revoir le match', en: 'Watch the replay' },
    'video.openYoutube': { fr: 'Ouvrir sur YouTube', en: 'Open on YouTube' },
    'video.broadcastOn': { fr: 'Diffusé le {date}', en: 'Broadcast on {date}' },
    'live.replay': { fr: 'Replay', en: 'Replay' },

    // ---------- Pied de page ----------
    'footer.partners': { fr: 'Partenaires officiels', en: 'Official partners' },
    'footer.legal': { fr: 'Mentions légales', en: 'Legal notice' },
    'footer.contact': { fr: 'Contact', en: 'Contact' },

    // ---------- Bandeau du haut ----------
    'top.shop': { fr: 'Boutique', en: 'Shop' },
    'top.press': { fr: 'Presse', en: 'Press' },
    'top.app': { fr: 'Appli FFTT', en: 'FFTT app' },
    'top.foundation': { fr: 'Fondation', en: 'Foundation' },
    'top.report': { fr: 'Je signale', en: 'Report an issue' },
    'top.account': { fr: 'Mon compte FFTT', en: 'My FFTT account' },

    // ---------- Playoffs ----------
    'playoffs.heroTitle': { fr: 'Playoffs', en: 'Playoffs' },
    'playoffs.heroTitleDown': { fr: 'Playoffs / Playdowns', en: 'Playoffs / Playdowns' },
    'playoffs.bracket': { fr: 'Tableau', en: 'Bracket' },
    'playoffs.roundQuarter': { fr: 'Quarts de finale', en: 'Quarter-finals' },
    'playoffs.roundSemi': { fr: 'Demi-finales', en: 'Semi-finals' },
    'playoffs.roundFinal': { fr: 'Finale', en: 'Final' },
    'playoffs.tbd': { fr: 'À déterminer', en: 'To be decided' },
    'playoffs.promotedProAM': { fr: 'Montée en Pro A Messieurs', en: 'Promoted to Pro A Men' },
    'playoffs.relegatedN1M': { fr: 'Descente en Nationale 1', en: 'Relegated to Nationale 1' },
    'playoffs.relegatedProBD': { fr: 'Le perdant descend en Pro B Dames', en: 'The loser is relegated to Pro B Women' },
    'playoffs.quitDemo': { fr: 'Quitter le mode démo', en: 'Leave demo mode' },
    'playoffs.demo': { fr: 'Mode démo : les résultats affichés sont fictifs.', en: 'Demo mode: the results shown are fictitious.' },
    'playoffs.seedOf': { fr: '{rank} du classement', en: 'Ranked {rank}' },
    'playoffs.winnerOf': { fr: 'Vainqueur {a} / {b}', en: 'Winner {a} / {b}' },
    'playoffs.loserOf': { fr: 'Perdant {a} / {b}', en: 'Loser {a} / {b}' },
    'playoffs.winnerSemi': { fr: 'Vainq. demi {n}', en: 'Winner SF {n}' },
    'playoffs.loserSemi': { fr: 'Perdant demi {n}', en: 'Loser SF {n}' },
    'playoffs.notFinished': { fr: "La saison régulière n'est pas terminée : les équipes qualifiées seront connues à l'issue de la dernière journée.", en: 'The regular season is not over yet: the qualified teams will be known after the last matchday.' },
    'playoffs.leg1': { fr: 'Aller', en: '1st leg' },
    'playoffs.leg2': { fr: 'Retour', en: '2nd leg' },
    'playoffs.hint': { fr: 'Cliquez sur un score pour voir la rencontre dans le calendrier.', en: 'Click a score to see the match in the calendar.' },
    'loader.playoffs': { fr: 'Chargement des playoffs…', en: 'Loading playoffs…' },
    'playoffs.playdowns': { fr: 'Playdowns', en: 'Playdowns' },
    'playoffs.places': { fr: 'Places {a} - {b}', en: 'Places {a} - {b}' },
    'playoffs.finalSingle': { fr: 'Finale sur un lieu unique', en: 'Single-venue final' },

    // ---------- Playoffs (accueil) ----------
    'playoffs.playoff': { fr: 'Play-Off', en: 'Play-off' },
    'playoffs.playdown': { fr: 'Play-Down', en: 'Play-down' },
    'playoffs.noData': { fr: 'Aucune donnée', en: 'No data' },

    // ---------- Site indisponible (erreur serveur 50x) ----------
    'unavailable.title': { fr: 'Site momentanément indisponible', en: 'Site temporarily unavailable' },
    'unavailable.text': { fr: 'Le site rencontre actuellement un problème technique. Merci de réessayer dans quelques instants.', en: 'The site is currently experiencing a technical issue. Please try again in a few moments.' },
    'unavailable.retry': { fr: 'Réessayer', en: 'Try again' },

    // ---------- Documentation (avertissement langue) ----------
    'docs.frenchOnly': { fr: 'Tous les documents présents sur cette page sont rédigés en français.', en: 'All documents on this page are written in French.' },
};
